export class LogEntry {
    timestamp: any;
    message: string;
}

export class LogContainer {
    logEntries = new Array<LogEntry>();

    public addLog(message: string) {
        const log = new LogEntry();
        log.timestamp = new Date().getDate();
        log.message = message;
        this.logEntries.push(log);
    }
}
